import React from "react";

const firebaseContext = React.createContext({data: { users: null, planets: null, getUses: null }});

export default firebaseContext;